import 'react-toastify/dist/ReactToastify.min.css'
import { ToastContainer as RTToastContainer } from 'react-toastify'
import styled from 'styled-components'

export * from 'react-toastify'

export const ToastContainer = styled(RTToastContainer)`
  font-family: Nunito Sans;
`
